import { default as common } from './common.json';
import { default as error } from './error.json';
import { default as date } from './date.json';
import { default as user } from './user.json';
import { default as booking } from './booking.json';
import { default as process } from './process.json';
import { default as processTable } from './processTable.json';
import { default as customer } from './customer.json';
import { default as welcome } from './welcome.json';
import { default as lab } from './lab.json';

/**
 * use t('common.signin') or use lib i18n.t('common.signin')
 */
export default {
	common,
	error,
	date,
	user,
	booking,
	customer,
	welcome,
	process,
	processTable,
	lab
};
